import { render, staticRenderFns } from "./EditorTypeCount.vue?vue&type=template&id=2e2951bc&scoped=true&lang=pug&"
import script from "./EditorTypeCount.vue?vue&type=script&lang=js&"
export * from "./EditorTypeCount.vue?vue&type=script&lang=js&"
import style0 from "./EditorTypeCount.vue?vue&type=style&index=0&id=2e2951bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2951bc",
  null
  
)

export default component.exports